import { Plus, Minus } from "lucide-react";
import { useState } from "react";

const FAQ_LIST = [
  {
    q: "How do I start selling on Amazon?",
    a: "We complete your Amazon Seller Central registration end-to-end — GST setup, brand documentation, category gating, FBA configuration and your first listing. Most brands go live within 7 days from kick-off.",
  },
  {
    q: "Which marketplaces do you support?",
    a: "Amazon, Flipkart, Meesho, JioMart, Ajio, Nykaa, Myntra, Tata Cliq, Blinkit, Zepto and Instamart. We onboard, manage and grow accounts across all of them.",
  },
  {
    q: "How long does seller onboarding take?",
    a: "Most marketplaces go live within 7 days. Premium platforms like Nykaa and Myntra typically take 3–6 weeks because of brand approval and catalog quality requirements.",
  },
  {
    q: "What documents are required?",
    a: "GST certificate, PAN, bank account proof, brand authorisation/trademark, address proof, HSN codes for products, and 2–3 product samples for QC. We share a checklist before kick-off.",
  },
  {
    q: "Do you provide ads & account management?",
    a: "Yes. We run Sponsored Products, Sponsored Brands, Display, Coupons, and seasonal deals — and we manage daily account ops (orders, returns, inventory, performance, customer service) with weekly P&L reporting.",
  },
  {
    q: "What is your pricing?",
    a: "We offer fixed-fee onboarding packages and monthly retainers for account management. Free 30-minute audit available so you know exactly what your engagement will look like before committing.",
  },
  {
    q: "Do you handle account suspensions?",
    a: "Yes. We have a 95%+ reinstatement success rate across Amazon, Flipkart and Meesho — including IP complaints, performance suspensions, and policy violations.",
  },
  {
    q: "Can I work with you if I'm a new D2C brand?",
    a: "Absolutely. Most of our clients start as new D2C brands. We've taken brands from zero to ₹1Cr+ in their first year on marketplaces.",
  },
  {
    q: "Do you build websites and apps too?",
    a: "Yes. We build Shopify, WooCommerce, custom Next.js storefronts, and native iOS/Android apps. We also integrate marketplaces, logistics, and payments.",
  },
  {
    q: "Do you work with brands in the USA and UAE?",
    a: "Yes. From our Mumbai office we manage Amazon.com, Walmart Marketplace and Shopify for brands selling in the USA, and Amazon.ae and Noon for brands in Dubai and the UAE, with calls scheduled in your business hours.",
  },
  {
    q: "Are you an authorized partner?",
    a: "Yes — Orina Enterprise is an Authorized Amazon Partner and Authorized JioMart Partner with direct relationships across category teams.",
  },
];

function FaqItem({ faq, idx, open, onToggle }) {
  return (
    <div className="border-2 border-black bg-white -mt-[2px]" data-testid={`faq-item-${idx}`}>
      <button
        type="button"
        onClick={onToggle}
        aria-expanded={open}
        aria-controls={`faq-answer-${idx}`}
        className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left md:px-7 md:py-6"
      >
        <span className="display text-base font-black tracking-tight md:text-lg">{faq.q}</span>
        <span
          className={`flex h-9 w-9 shrink-0 items-center justify-center border-2 border-black transition-colors ${
            open ? "bg-black text-[#FFD700]" : "bg-[#FFD700] text-black"
          }`}
        >
          {open ? <Minus size={16} /> : <Plus size={16} />}
        </span>
      </button>
      {/* Always in the DOM (hidden when closed) so every answer is in the page HTML. */}
      <div id={`faq-answer-${idx}`} hidden={!open} className="border-t-2 border-black bg-[#FAFAF7] px-5 py-5 md:px-7 md:py-6">
        <p className="text-sm leading-relaxed text-black/85 md:text-base">{faq.a}</p>
      </div>
    </div>
  );
}

export default function FaqAccordion({ limit }) {
  const [openIdx, setOpenIdx] = useState(0);
  const items = limit ? FAQ_LIST.slice(0, limit) : FAQ_LIST;
  return (
    <div data-testid="faq-accordion">
      {items.map((f, i) => (
        <FaqItem
          key={f.q}
          faq={f}
          idx={i}
          open={openIdx === i}
          onToggle={() => setOpenIdx(openIdx === i ? -1 : i)}
        />
      ))}
    </div>
  );
}

export { FAQ_LIST };
